'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var portal = require('@shadom/portal');
var jsonp = require('jsonp');
var qs = require('qs');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var jsonp__default = /*#__PURE__*/_interopDefaultLegacy(jsonp);

class JsonPPortal extends portal.Portal {
    constructor(config) {
        config.addr = config.addr || config.uri;
        super(config, {
            payload: ['queries'],
            transmit: []
        });
    }
    async transmit(payloads) {
        let uri = this.addr;
        let queryString = qs.stringify(payloads.param || payloads.queries);
        let sep = (~uri.indexOf('?')) ? '&' : '?';
        uri = `${uri}${sep}${queryString}`;
        return new Promise((resolve, reject) => {
            jsonp__default["default"](uri, {
                'param': 'callback',
                // 'timeout': this.options.,
            }, (err, data) => {
                if (err) {
                    reject(err);
                }
                else {
                    resolve(data);
                }
            });
        });
    }
    ;
}

exports.JsonPPortal = JsonPPortal;
